import { useEffect, useMemo } from "react";
import { primeAudio, playPattern } from "../services/soundCore";

/**
 * Sound only when app is visible. Background = no sound (only system push).
 */
export function useSound() {
  // Unlock audio after first user gesture
  useEffect(() => {
    const onGesture = () => {
      primeAudio();
    };
    window.addEventListener("click", onGesture, { passive: true });
    window.addEventListener("touchstart", onGesture, { passive: true });
    return () => {
      window.removeEventListener("click", onGesture);
      window.removeEventListener("touchstart", onGesture);
    };
  }, []);

  return useMemo(() => {
    return {
      play(name = "default") {
        if (document.visibilityState !== "visible") return;
        playPattern(name);
      },
      playFromPush(payload) {
        if (document.visibilityState !== "visible") return;

        const t = payload?.type || payload?.event || payload?.kind || "";
        if (t === "chat_message" || t === "message") return playPattern("chat");
        if (t === "order_new" || t === "order_assigned") return playPattern("order");
        if (t === "status_changed") return playPattern("status");

        // fallback
        playPattern("default");
      },
    };
  }, []);
}
